import React from 'react';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';
export function SocialProof() {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className="pt-8 border-t border-slate-200" data-id="element-33">
      <h3 className="text-2xl font-bold text-center text-slate-900 mb-8" data-id="element-34">
        Lo que dicen nuestros miembros
      </h3>

      <div className="max-w-md mx-auto bg-white rounded-2xl border border-slate-200 shadow-lg overflow-hidden" data-id="element-35">
        <div className="aspect-square w-full overflow-hidden bg-slate-100" data-id="element-36">
          <img src="https://cdn.magicpatterns.com/uploads/p7m52XRiacpEFzDioqCcFn/pasted-image.png" alt="Mario P., comerciante" className="w-full h-full object-cover" data-id="element-37" />
        </div>
        <div className="p-6" data-id="element-38">
          <div className="flex gap-1 mb-4" data-id="element-39">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-40" />)}
          </div>
          <p className="text-slate-800 text-base md:text-lg leading-relaxed mb-4 italic" data-id="element-41">
            "Chusmeando un poco lo que me mandaron al correo, ya tengo 2 que voy
            a lanzar a vender junto con las cartas del mundial!!! contento"
          </p>
          <p className="text-slate-500 text-sm font-medium" data-id="element-42">
            — Mario P., comerciante
          </p>
        </div>
      </div>
    </motion.div>;
}